import { getMySmsNotificationPrice } from "@rentiohq/shared-frontend/dist/reduxV2/pricing/pricing.api";
import React from "react";

/**
 * What one SMS costs the office, excluding VAT, from the pricing billing
 * charges it on, never a figure written into the screen (DEV-3553).
 *
 * Undefined while loading, and for good when it fails or no pricing covers
 * today: the screen then leaves the price out rather than showing a guess.
 */
export const useSmsNotificationPrice = (params: { shouldFetch: boolean }) => {
  const { shouldFetch } = params;

  const [price, setPrice] = React.useState<number | undefined>();

  React.useEffect(() => {
    if (!shouldFetch) {
      return;
    }

    let isCurrent = true;

    getMySmsNotificationPrice()
      .then(response => {
        const smsNotification = response.data.data?.smsNotification;

        if (isCurrent && typeof smsNotification === "number") {
          setPrice(smsNotification);
        }
      })
      .catch(() => {
        // Nothing to tell the office: the line simply goes without a price.
      });

    return () => {
      isCurrent = false;
    };
  }, [shouldFetch]);

  return price;
};
